import { Box } from "../../../box";
import { BreakpointProvider } from "../BreakpointProvider";
import { useColorScheme } from "../useColorScheme";
import { mergeClasses, mergeProps } from "../../../shared";
import { useCallback, useState } from "react";
import { ThemeContext } from "./ThemeContext";
import { getColorSchemeClassName, getThemeClassName } from "./createThemeVars";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function ThemeProvider({
  as = DefaultElement,
  children,
  colorScheme,
  defaultColorScheme,
  theme,
  ...rest
}) {
  const [remoteColorScheme, setRemoteColorScheme] = useState();
  const computedColorScheme = useColorScheme(remoteColorScheme !== null && remoteColorScheme !== void 0 ? remoteColorScheme : colorScheme, defaultColorScheme);
  const setColorScheme = useCallback(newColorScheme => {
    setRemoteColorScheme(newColorScheme);
  }, [setRemoteColorScheme]);
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: {
      colorScheme: computedColorScheme,
      setColorScheme,
      theme
    },
    children: /*#__PURE__*/_jsx(BreakpointProvider, {
      children: /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
          as,
          className: mergeClasses("o-ui", getThemeClassName(theme.name), getColorSchemeClassName(theme.name, computedColorScheme))
        }),
        children: children
      })
    })
  });
}